import { Component, OnInit,Inject,HostListener } from '@angular/core';
import { HelperService } from '../helper.service';
import { Router,ActivatedRoute, Params } from '@angular/router';
import {MatSnackBar} from '@angular/material';
import { Http, Response,Headers } from '@angular/http';
import { DataTableDirective } from 'angular-datatables';
import { Subject } from 'rxjs/Subject';
import { NgForm } from '@angular/forms';
import {MatDialog} from '@angular/material';
import {MAT_DIALOG_DATA,MatDialogRef} from '@angular/material';
import {CookieService} from 'angular2-cookie/core';

@Component({
  selector: 'app-doubt',
  templateUrl: './doubt.component.html',
  styleUrls: ['./doubt.component.css'],
   providers: [HelperService]
})
export class DoubtComponent implements OnInit {

  // 	@HostListener('window:beforeunload', ['$event'])
//   unloadHandler(event: Event) {
//   localStorage.removeItem('access_token');
//   localStorage.removeItem('navigateroute');
// }
 dtOptions: DataTables.Settings = {};
  dtElement: DataTableDirective;
  doubts:any=[];
  dtTrigger: Subject<any> = new Subject();
  btn_disable=false;
  btn_class='btn';
  //user=this.cookie.get('user_id');
  studentid;
  datas;
  teacherroles;
  user_roleid;checkIfTeacher;
  user_permissions:any=[];
  user_token= localStorage.getItem('access_token');
  private headers: Headers = new Headers({
  'Accept': 'application/json',
  'Authorization': "Bearer "+this.user_token
});
  constructor(private helper:HelperService,private http:Http,private cookie:CookieService,private snackbar: MatSnackBar,private activatedRouter:ActivatedRoute,private router:Router,public dialog: MatDialog) {
    activatedRouter.queryParams.subscribe(params => {

      if(params['student'])
        this.studentid = params['student'];
      else
        this.studentid = '';

  });
       
}

  ngOnInit() {
    let user=this.cookie.get('user_id');
    this.http.get(this.helper.base_url+'/http/get/user/permissions',{ headers: this.headers })
    
    .subscribe(data => {
      this.user_permissions = JSON.parse(data['_body']);
     //console.log(this.user_permissions);
        
     
    });
    this.http.get(this.helper.base_url+'http/get/checkusers',{ headers: this.headers })
    
    .subscribe(data => {
      let body = JSON.parse(data['_body']);
      //alert(body.success);
      // this.datas = JSON.parse(data['_body']).users[0];
      // this.user_roleid = JSON.parse(data['_body']).users[0]['role_id'];
      // //console.log(this.datas);
      // this.teacherroles = JSON.parse(data['_body']).teacherroles;
      // console.log(this.teacherroles);
      // console.log(this.user_roleid);
      //console.log(this.teacherroles.includes(this.user_roleid));
      //this.checkIfTeacher = this.teacherroles.includes(this.user_roleid);
      this.checkIfTeacher = body.success;
    if(this.checkIfTeacher == false)
    {
      this.dtOptions = {
        pagingType: 'full_numbers',
        pageLength: 10
      };
  
       this.http.get(this.helper.base_url+'http/get/doubt?student_id='+this.studentid,{ headers: this.headers })
        
        .subscribe(data => {
          this.doubts = JSON.parse(data['_body']);
          
            this.dtTrigger.next();
          
         
        });
    }
    else
    {
      this.dtOptions = {
        pagingType: 'full_numbers',
        pageLength: 10
      };
  
       this.http.get(this.helper.base_url+'http/get/teacherdoubt',{ headers: this.headers })
        
        .subscribe(data => {
          this.doubts = JSON.parse(data['_body']);
          
            this.dtTrigger.next();
          
         
        });
    }
    });

    

  
      

  }
   add_reply_doubt(id,reply){
     //console.log(this.user);
     if(reply!=''){
        this.http.get(this.helper.base_url+'http/add/doubt_reply?id='+id+'&reply='+reply,{ headers: this.headers })
      .subscribe(data => {

        this.refresh() ;
      });
    }else{
      this.snackbar.open('Field Required', null, {
    duration:5000,
      extraClasses:'error-snackbar',
      verticalPosition:'top'
    });
    }
    
  }
    doubt_change(event,value)
{
  
 if(value!=''){
this.btn_disable=true;
this.btn_class='btn btn-primary';
 }else{
this.btn_disable=false;
this.btn_class='btn';
 }
}
     refresh(val=false){
   
  this.snackbar.open('Message sent successfully', null, {
    duration:5000,
      extraClasses:'success-snackbar',
      verticalPosition:'top'
    });
  this.router.navigateByUrl('/redirect', {skipLocationChange: true}).then(()=>
  this.router.navigate(["doubtlist"]));
      
 }
  openDialog(data) {
    const dialogRef = this.dialog.open(ReplyDialogBox, {
      height: '350px',
       width: '1000px',
      data: { data: data,base_url:this.helper.base_url },
    });

    dialogRef.afterClosed().subscribe(result => {
      //console.log(`Dialog result: ${result}`);
    });
  }
  openRemarkDialog(data) {
    const dialogRef = this.dialog.open(RemarkDialogBox, {
      height: '350px',
       width: '1000px',
      data: { data: data,base_url:this.helper.base_url },
    });

    dialogRef.afterClosed().subscribe(result => {
      console.log(`Dialog result: ${result}`);
    });
  }

}
@Component({
  selector: 'reply-dialog-box',
  templateUrl: "reply-dialog-box.html",
})
export class ReplyDialogBox {
  users:any=[];
  foods:any=[];
 name='';
  doubt='';
 base_url;
 id;
  dialog=MAT_DIALOG_DATA;
  //user=this.cookie.get('user_id');
  user_token= localStorage.getItem('access_token');
  private headers: Headers = new Headers({
  'Accept': 'application/json',
  'Authorization': "Bearer "+this.user_token
});
  constructor(public dialogRef: MatDialogRef<DoubtComponent>,@Inject(MAT_DIALOG_DATA) public data: any,private http:Http,private cookie:CookieService,private snackbar: MatSnackBar,private router:Router) {
    this.name=data.data.student;
    this.doubt=data.data.doubt;
    this.base_url=data.base_url;
    this.id=data.data.id;
  
  }
 add_reply_doubt(reply){

     if(reply!=''){
        this.http.get(this.base_url+'http/add/doubt_reply?id='+this.id+'&reply='+reply,{ headers: this.headers })
      .subscribe(data => {
this.dialogRef.close();
        this.refresh() ;
      });
    }else{
      this.snackbar.open('Field Required', null, {
    duration:5000,
      extraClasses:'error-snackbar',
      verticalPosition:'top'
    });
    }
    
  }  
  refresh(val=false,msg=''){
   
  this.snackbar.open('Reply send successfully', null, {
    duration:5000,
      extraClasses:'success-snackbar',
      verticalPosition:'top'
    });
  this.router.navigateByUrl('/redirect', {skipLocationChange: true}).then(()=>
  this.router.navigate(["doubtlist/"]));
      
 }
  ngOnInit() { }
}


@Component({
  selector: 'remark-dialog-box',
  templateUrl: "remark-dialog-box.html",
})
export class RemarkDialogBox {
  users:any=[];
  foods:any=[];
 name='';
  doubt='';
 base_url;
 id;
  dialog=MAT_DIALOG_DATA;
  //user=this.cookie.get('user_id');
  user_token= localStorage.getItem('access_token');
  private headers: Headers = new Headers({
  'Accept': 'application/json',
  'Authorization': "Bearer "+this.user_token
});
  constructor(public dialogRef: MatDialogRef<DoubtComponent>,@Inject(MAT_DIALOG_DATA) public data: any,private http:Http,private cookie:CookieService,private snackbar: MatSnackBar,private router:Router) {
    this.name=data.data.student;
    this.doubt=data.data.doubt;
    this.base_url=data.base_url;
    this.id=data.data.id;
  
  }
 add_remark_doubt(remark){

     if(remark!=''){
        this.http.get(this.base_url+'http/add/doubt_remark?id='+this.id+'&remark='+remark,{ headers: this.headers })
      .subscribe(data => {
this.dialogRef.close();
        this.refresh() ;
      });
    }else{
      this.snackbar.open('Field Required', null, {
    duration:5000,
      extraClasses:'error-snackbar',
      verticalPosition:'top'
    });
    }
    
  }  refresh(val=false,msg=''){
   
  this.snackbar.open('Remark Added successfully', null, {
    duration:5000,
      extraClasses:'success-snackbar',
      verticalPosition:'top'
    });
  this.router.navigateByUrl('/redirect', {skipLocationChange: true}).then(()=>
  this.router.navigate(["doubtlist/"]));
      
 }
  ngOnInit() { }
}


// WEBPACK FOOTER //
// ./src/app/doubt/doubt.component.ts